import {
  GCC_ALPHA3_CODES,
  GCC_CODES,
  GCC_ISD_CODES,
  type RegionalBaseUrls,
} from "./constants";

export function getRegion(countryCode: string): keyof RegionalBaseUrls {
  const normalized = countryCode.trim().toUpperCase();
  const isdCode = normalized.replace(/\D/g, "");

  if (normalized === "US" || normalized === "USA" || isdCode === "1") {
    return "US";
  }
  if (
    GCC_CODES.has(normalized) ||
    GCC_ALPHA3_CODES.has(normalized) ||
    GCC_ISD_CODES.has(isdCode)
  ) {
    return "GCC";
  }
  return "IN";
}
